import {
  IFingerprintSearchResult,
  KindredCouponCoverage,
} from "../../interfaces";

/** Shared so the targeting search and the advertiser panel create identical targets. */
export const buildProductTargetPayload = (
  match: IFingerprintSearchResult,
  domain: string
) => ({
  coverage: KindredCouponCoverage.Product,
  merchantDomain: domain,
  advertiserId: match.product.advertiserId || null,
  categoryPath: match.product.categories?.[0] || null,
  manufacturerName: match.product.manufacturer || null,
  productMerchantProductId:
    match.product.merchantProductId || match.product.id || null,
  productSku: match.product.sku || null,
  productEan: match.product.ean || null,
  productGtin: match.product.gtin || null,
  productUpc: match.product.upc || null,
  productMpn: match.product.mpn || null,
  productName: match.product.name?.trim() || null,
  productUrl: match.product.productUrl || null,
  directNetwork: match.product.affiliateNetwork || null,
  canonicalKey: match.product.canonicalKey || null,
});
